import React from 'react';
import { onClickBtnSalesType } from 'actions/businessLibrary/item';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import SalesTypeItemVariantsList from './SalesTypeItemVariantsList';

class SalesTypeItemVariantsFieldArray extends React.Component {
  render() {
    const { fields } = this.props;
    return (
      <div>
        {fields.map((member, index) => {
          if (fields.get(index).selected) {
            return (
              <SalesTypeItemVariantsList
                fields={fields}
                key={index}
                index={index}
              />
            );
          }
        })}
        <div className="row">
          <div className="form-group col-sm-12">
            <button
              onClick={this._onClickSalesType}
              className="btn btn-primary btn-block no-border-radius-top"
            >
              {fields.length > 1 ? 'Manage Sales Type' : 'Add Sales Type'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  _onClickSalesType = e => {
    const { dispatch, item } = this.props;
    dispatch(onClickBtnSalesType(item));
    e.stopPropagation();
    e.preventDefault();
  };
}

function mapStateToProps(state) {
  const {
    moka: { user },
  } = state;
  const {
    item: { outlets },
  } = state.library;
  return {
    item: getFormValues('itemHub')(state),
    user,
    outlets,
  };
}

export default connect(mapStateToProps)(SalesTypeItemVariantsFieldArray);
